import React from "react";
//Material imports
import Grid from "@mui/material/Grid";
//Limitless imports
import DashBoradTile from "@limitless/modern/components/tile/Tile";
import { useExpertProfileContext, useExpertDashboard, useExpertPendingQuestionsContext } from "@limitless/expert";
import { useTranslation} from "@limitless/common/hooks";
import { formatRating } from "@limitless/common/utils";

const DashboardTile = () => {
    const { profile, getFormattedBalance } = useExpertProfileContext();
    const { loadExpertPendingQuestions } = useExpertPendingQuestionsContext();
    const { balance, custRating } = profile;
    const { t } = useTranslation();
    const {
        taskCompleted,
        trendingStatus,
        trendingRate,
        paymentValueThreshold,
        pendingFeesCount,
        fetchDashboardStats
    } = useExpertDashboard();

    React.useEffect(() => {
        loadExpertPendingQuestions();
        fetchDashboardStats();
    }, []);

    return (
        <Grid container spacing={2} sx={{ padding: "24px 0px 24px 24px" }}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
                <DashBoradTile
                    label={balance > paymentValueThreshold ? t("Available to payout") : t("Current balance")}
                    value={getFormattedBalance()}
                    rightLabel={balance > paymentValueThreshold ? t("Payout") : t("Go to Payments")}
                    subLabel={
                        pendingFeesCount !== 0 &&
                        t("up to {0} will be available soon ", getFormattedBalance(pendingFeesCount))
                    }
                    isButton
                    tooltip={t(
                        "Some of your tasks are currently pending fee allocation. Check payments for more details"
                    )}
                    url="/payment"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
                <DashBoradTile
                    label={t("Rating")}
                    subLabel=""
                    rightLabel="Learn More"
                    url="/dashboard/ratings"
                    value={formatRating(custRating)}
                    isButton
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={4}>
                <DashBoradTile
                    label={t("Tasks completed")}
                    subLabel={t("all task types")}
                    rightLabel={t("last 7 days")}
                    value={taskCompleted.length !== 0 ? taskCompleted : 0}
                    trendingRate={trendingRate > 1 && trendingRate.toFixed(0)}
                    trendingStatus={trendingStatus}
                    isButton={false}
                />
            </Grid>
        </Grid>
    );
};

export default DashboardTile;
